import React from "react";
import Footer from "../Footer";
import Navbar from "../Navbar";
import image1 from "../../assets/image1.jpg";

const RiskManagementPolicy: React.FC = () => {
  const policySections = [
    {
      title: `1. ${import.meta.env.VITE_COMPANY_NBFC} (Brand Name: ${import.meta.env.VITE_COMPANY_NAME})`,
      content: `1.1 The Board of Directors (“Board”) of ${import.meta.env.VITE_COMPANY_NAME} (“Company”) has adopted the following policy, encompassing practices relating to identification, assessment, monitoring, and mitigation of various business risks.

1.2 The Risk Management Policy (“Policy”) aims to minimize unfavorable impacts on business objectives and enhance stakeholder value. It is also designed to sustain and strengthen the Company’s long-term competitive advantage.`,
    },
    {
      title: "2. Purpose",
      content: `2.1 This Policy has been framed in accordance with the Risk Management Framework issued by the Reserve Bank of India (RBI) vide Master Direction DNBR. PD. 008/03.10.119/2016-17 dated September 1, 2016, and subsequent amendments.

2.2 The Policy aims to address potential losses to the Company’s human and financial assets while maintaining flexibility in pursuing growth-oriented activities that align with the Company's goals.`,
    },
    {
      title: "3. Principles",
      list: [
        "Risk management must create and protect value.",
        "It must be integrated into organizational processes.",
        "It supports informed decision-making.",
        "It focuses on uncertainties surrounding objectives.",
        "It must be tailored to the business context.",
        "It must be dynamic, iterative, and responsive to change.",
      ],
    },
    {
      title: "4. Definitions",
      list: [
        "Board: Board of Directors of the Company.",
        `Company: ${import.meta.env.VITE_COMPANY_NAME}.`,
        "Directors: Members of the Board.",
        "Policy: Risk Management Policy.",
        "RBI: Reserve Bank of India.",
      ],
    },
    {
      title: "5. Policy Objectives",
      list: [
        "Continuously identify organizational risks affecting business operations.",
        "Safeguard shareholder rights and value through a comprehensive risk management framework.",
        "Enhance and maintain tools and processes to support strategic and operational decision-making.",
      ],
    },
    {
      title: "6. Risk Identification, Measurement, and Assessment",
      content: `6.1 Management, under the Board’s oversight, is responsible for implementing the Risk Management Program and risk identification processes.

6.2 Risks are measured through qualitative and quantitative methods based on likelihood and impact.

6.3 Risks are categorized into inherent and residual types depending on their potential effect.

6.4 Key Risk Categories Identified:`,
      list: [
        "Strategic Risk",
        "Operational Risk",
        "Market Risk",
        "Financial Risk",
        "Credit & Concentration Risk",
        "Regulatory & Compliance Risk",
        "Human Resource Risk",
      ],
    },
  ];

  return (
    <div className="min-w-screen text-white py-16 px-4">
      <div className="max-w-7xl mx-auto flex flex-col gap-12">
        <Navbar />

        {/* Hero Section */}
        <section className="relative m-auto text-center py-16 rounded-xl shadow-lg px-6 md:px-12 overflow-hidden w-full max-w-4xl bg-[#F26622]/10">
          <img
            src={image1}
            alt="Risk Management Policy"
            className="absolute inset-0 w-full h-full object-cover opacity-20 rounded-xl"
          />
          <div className="relative z-10">
            <h1 className="text-4xl sm:text-5xl font-bold mb-4 text-white drop-shadow-lg">
              Risk Management Policy
            </h1>
            <p className="text-white text-lg sm:text-xl max-w-3xl mx-auto leading-relaxed mt-4">
              At{" "}
              <span className="font-semibold text-white">
                {import.meta.env.VITE_COMPANY_NAME}
              </span>
              , our risk management framework ensures early identification,
              assessment, and mitigation of business risks to protect company
              value and foster sustainable growth.
            </p>
          </div>
        </section>

        {/* Policy Content */}
        <div className="max-w-4xl w-full mx-auto p-8 rounded-xl bg-white  shadow-md text-gray-800 space-y-6 ">
          {policySections.map((section, idx) => (
            <div key={idx} className="space-y-2">
              <h2 className="text-2xl font-semibold text-[#FF2D55]">
                {section.title}
              </h2>
              {section.content && (
                <p className="text-gray-700 whitespace-pre-line leading-relaxed">
                  {section.content}
                </p>
              )}
              {section.list && (
                <ul className="list-disc list-inside ml-4 space-y-1 text-gray-700">
                  {section.list.map((li, i) => (
                    <li key={i}>{li}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default RiskManagementPolicy;
